import { useState } from "react";
import { faqItems } from "../../../mocks/services";

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-arch-cream">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">Common Questions</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-arch-charcoal font-light leading-tight">
              FAQ
            </h2>
          </div>
          <p className="text-arch-gray text-sm font-light max-w-xs">
            Answers to the most common questions about working with an architecture firm.
          </p>
        </div>

        <div className="divide-y divide-arch-border">
          {faqItems.map((item, i) => (
            <div key={i} className="py-6">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between text-left gap-4 cursor-pointer group"
              >
                <h3 className="text-arch-charcoal text-sm lg:text-base font-medium leading-snug group-hover:text-arch-gray transition-colors">
                  {item.question}
                </h3>
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 border border-arch-border rounded-full">
                  <i
                    className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-arch-charcoal text-sm transition-all`}
                  />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  open === i ? "max-h-48 opacity-100 mt-4" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-arch-gray text-sm font-light leading-relaxed max-w-2xl">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
